import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth0Integration } from '../contexts/Auth0Context';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

const Auth0Callback = () => {
  const navigate = useNavigate();
  const { isAuthenticated: isAuth0Authenticated, getAccessTokenSilently, user: auth0User } = useAuth0Integration();
  const { user: appUser } = useAuth();

  useEffect(() => {
    const handleAuth0Callback = async () => {
      if (isAuth0Authenticated && !appUser) {
        try {
          // Get Auth0 access token
          const auth0Token = await getAccessTokenSilently();
          
          // Send to backend to sync user and get API token
          const response = await axios.post(`${API_URL}/auth0/callback`, {
            access_token: auth0Token
          });

          if (response.data.success) {
            const { access_token, user } = response.data;
            
            // Store API token
            localStorage.setItem('token', access_token);
            axios.defaults.headers.common['Authorization'] = `Bearer ${access_token}`;
            
            toast.success(`Bienvenue ${user.name}!`);
            
            // Redirect based on role
            if (user.role === 'superadmin') {
              navigate('/superadmin');
            } else {
              navigate('/dashboard');
            }
          }
        } catch (error) {
          console.error('Auth0 callback error:', error);
          toast.error('Erreur lors de la connexion Auth0');
          navigate('/login');
        }
      }
    };

    handleAuth0Callback();
  }, [isAuth0Authenticated, appUser, getAccessTokenSilently, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50" data-testid="auth0-callback">
      <div className="text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-indigo-700 mx-auto"></div>
        <p className="mt-4 text-slate-600">Connexion en cours avec Auth0...</p>
      </div>
    </div>
  );
};

export default Auth0Callback;
